import { getRoute } from "@/functions/getRoute";
import { convertColorName } from "@/functions/convertColorName";

const defaultConfig = {
  titleKey: "title",
  descriptionKey: "description",
  imgKey: "header_image",
  headerTextColorKey: "header_text_color",
  headerBackgroundColorKey: "header_background_color",
  headerImagePositionKey: "header_image_position",
};

export const header = ({ page, prevPage, config: __config, ...props }) => {
  const config = Object.assign({}, defaultConfig, __config);

  // use legacy version if config.imgKey is not set
  if (!(config.imgKey in page) || !page[config.imgKey]) {
    return headerLegacy({ page, prevPage, config: __config, ...props });
  }

  const textColor = convertColorName(page[config.headerTextColorKey].toLowerCase() ?? "tertiary");
  const backgroundColor = convertColorName(page[config.headerBackgroundColorKey].toLowerCase() ?? "light");

  return {
    component: "Header",
    props: {
      className: `text-${textColor} bg-${backgroundColor}`,
      title: page[config.titleKey] ?? null,
      description: page[config.descriptionKey] ?? null,
      img: page[config.imgKey] ?? null,
      back: {
        path: `page.${prevPage ? prevPage.url_slug : "home"}.component.Header.back`,
        placeholder: `Back to ${prevPage ? prevPage.label : "Home"} `,
        href: prevPage ? prevPage.href : getRoute("home"),
      },
      variant: page[config.headerImagePositionKey] ?? "Under Text",
      ...props,
    },
  };
};

/**
 * Legacy Header
 */

const legacyConfig = {
  titleKey: "title",
  descriptionKey: "description",
  classNameKey: "header_classes",
  imgKey: "cover_image",
};

const headerLegacy = ({ page, prevPage, config, ...props }) => {
  config = Object.assign({}, legacyConfig, config);

  return {
    component: "Header",
    props: {
      className: page[config.classNameKey] ? page[config.classNameKey] : "bg-primary text-white",
      title: page[config.titleKey],
      description: page[config.descriptionKey] ?? null,
      img: page[config.imgKey] ?? null,
      back: {
        path: `page.${prevPage ? prevPage.url_slug : "home"}.component.Header.back`,
        placeholder: `Back to ${prevPage ? prevPage.label : "Home"} `,
        href: prevPage ? prevPage.href : getRoute("home"),
      },
      containerClassName: "mw-xxl",
      variant: "Under Text",
      ...props,
    },
  };
};
